if (!customElements.get("td-hotspot")) {
  class TdHotspot extends HTMLElement {
    constructor() {
      super();

      this.trigger = this.querySelector("[data-hotspot-trigger]");
      this.triggerPing = this.querySelector("[data-hotspot-ping]");
      this.card = this.querySelector("[data-hotspot-card]");
      this.close = this.querySelector("[data-hotspot-close]");

      this.observer = new IntersectionObserver(this.handlePing.bind(this));
    }

    connectedCallback() {
      if (!this.trigger || !this.card || !this.close) {
        return;
      }
      setTimeout(() => {
        this.attachListeners();
      });
    }

    attachListeners() {
      this.trigger.addEventListener(
        "click",
        this.handleHotspotOpen.bind(this)
      );
      this.close.addEventListener(
        "click",
        this.handleHotspotClose.bind(this)
      );
      window.addEventListener("click", (event) => {
        if (!this.contains(event.target)) {
          this.handleHotspotClose();
        }
      });
      window.addEventListener("load", (event) => {
        this.observer.observe(this.trigger);
      });
    }

    handleHotspotOpen() {
      this.card.classList.add("hotspot-active");
      if (this.triggerPing.classList.contains("hotspot-active")) {
        this.triggerPing.classList.remove("hotspot-active");
      }
    }

    handleHotspotClose() {
      this.card.classList.remove("hotspot-active");
      if (!this.triggerPing.classList.contains("hotspot-active")) {
        this.triggerPing.classList.add("hotspot-active");
      }
    }

    handlePing(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.triggerPing.classList.add("hotspot-active");
        } else {
          this.triggerPing.classList.remove("hotspot-active");
        }
      });
    }
  }

  customElements.define("td-hotspot", TdHotspot);
}